<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row">
        <div v-show="showData" class="col-lg-12">
          <h3>Parking License Application Terms and Conditions</h3>
          <br>
          <br>
            
          <div class="ibox-content no-padding">
            <div id="tnc" class="summernote">
            </div>
          </div>

        </div>
      </div>

      <br>

      <button v-show="allowSave && showData" v-on:click="onSaveButtonClick" type="button" class="btn btn-primary">
        Save
      </button>

      <br>
      <br>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

export default {
  name: "PageRegistrationTnC",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    AppForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'Parking License Management' },
        { name: 'Registration T&C' },
      ],

      showData: false,
      allowSave: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(helper.hasEditPermission(this.permission)) {
      this.allowSave = true;
    }

    $('.summernote').summernote({
      minHeight: '300px'
    });
    
    // this.loadCity();
    this.loadData();
  },
  methods: {
    loadData() {
      let feedbackItem = 'T&C'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          // helper.SERVER_URL + '/api2/configure',
          helper.SERVER_URL + '/api2/policy/terms',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.configure = response.data[0] || {};
          $('#tnc').summernote('code', this.configure.policy);
          this.showData = true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    onSaveButtonClick() {
      this.configure.policy = $('#tnc').summernote('code');

      let feedbackItem = 'T&C'
      this.$refs['pageFeedback'].setFeedbackLoading('Saving ' + feedbackItem);
      this.$http
        .post(
          // helper.SERVER_URL + '/api2/configure',
          helper.SERVER_URL + '/api2/policy/terms',
          querystring.stringify(this.configure),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully save ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'saving', feedbackItem));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageRegistrationTnC.vue